module.exports = __webpack_public_path__ + "static/media/maskModal.44641f66.svg";